module.exports = __webpack_public_path__ + "img/20190713125056YY截图20190712232747.4d07a8e3.png";